import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Subscription, Subject, Observable } from 'rxjs'
import { DateTime } from 'typescript-dotnet-es6/System/Time/DateTime'


import { AuditStdImport } from '../utilities/auditstd-import-model';
import { AuditStdEdit } from '../utilities/auditstd-edit-model';
import { KeywordManager } from '../../../../core/keyword-manager';
import { GDSCredentials } from '../../../../core/models/gds-credentials-model';
import { AddDaysToDate, RaService, MsgResult } from '../../../../core';
import { UserProfileService, CustomersService, ProductData, CustomerModel } from '../../../../core';
import { EnumAlertType, AlertComponent } from '../../../../common/component/alert/alert.component';
import { PopupSettings } from '@progress/kendo-angular-dropdowns';

interface SimpleIDName { id: string, name: string };
interface Notification { id: string, name: string, isDefault: boolean };

@Component({
  selector: 'app-process-settings',
  templateUrl: './process-settings.component.html',
  styleUrls: ['./process-settings.component.scss']
})

export class ProcessSettingsComponent implements OnInit {
  @Input() isQuickAudit: boolean;
  @ViewChild(AlertComponent, { static: true }) alerter: AlertComponent;
  validateEmail: boolean = false;
  data: CustomerModel;

  constructor(
    private raService: RaService
    , private userProfileService: UserProfileService
    , private customersService: CustomersService
  ) {
    let start = this.now().addYears(-1).year;
    this.contractYearList = [(start++).toString(), (start++).toString(), (start++).toString()];
    const scheduled = AddDaysToDate(this.now(), 1);
    this.scheduledDate = scheduled.toJsDate();
    this.scheduledTime = scheduled.addHours(7).toJsDate();

    this.earliestRunDate = this.now().date.toJsDate();
    this.lastRunDate = AddDaysToDate(this.now(), 91).toJsDate();

  }


  async ngOnInit() {
    let user = this.userProfileService.data;
    this.LOSIsLicensed = user.ProductAccess.indexOf('LOS') > -1;
    this.data = await this.customersService.GetCustomer().toPromise();
  }


  @Input("toConfirmDlg") toConfirmDlg: { confirmDlg: (msg: string, msg2: string, title: string, cancelButton?: boolean) => Observable<boolean> };
  @Output() verifyEmailAdd: EventEmitter<boolean> = new EventEmitter();
  now: () => DateTime = () => DateTime.now;

  buildNotification: boolean = false;
  dropdownPopupSettings: PopupSettings;
  _notificationTemplateList: Notification[] = [];
  set notificationTemplateList(data: Notification[]) {
    this._notificationTemplateList = data;
    if (data.length > 0) {
      this.notificationSelection = data[0].id;
      this.notificationName = data[0].name;
      let dfault = data.filter(q => q.isDefault ? true : false);
      if (dfault.length > 0) {
        this.notificationSelection = dfault[0].id;
        this.notificationName = dfault[0].name;
      }
    }
  }
  notificationName: string = "";
  notificationSelection: string = "1";//"Failed Audit Template";
  contractYearList: string[] = ['2016', '2017', '2018'];
  contractYear: string = "";
  accountTypeList: SimpleIDName[] = [{ id: 'C', name: '[C] Corporate' }, { id: 'N', name: '[N] Negotiated' }, { id: 'X', name: '[X] Consortia' }];
  accountType: string = '';
  originalKeywordList: string = ''
  //keywordList: [{ textContent: string,[key:string]:string }] = [{k:'',textContent:''}];
  keywordList: { textContent: string }[] = [];
  racAmadeus: string = "";
  racApollo: string = "";
  racGalileo: string = "";
  racSabre: string = "";
  racWorldspan: string = "";

  keywordToAdd: string = "";
  _editedAudit: AuditStdEdit = new AuditStdEdit(new AuditStdImport(), false, "");
  auditWillBeScheduled: boolean = false;
  runAuditNow: boolean = true;
  set editedAudit(data: AuditStdEdit) {
    this._editedAudit = data;
    this.contractYear = data.ContractYear;
    this.disableAuditAmadeus = (this.gdsCredentials && this.gdsCredentials.AmadeusActive) ? false : true;
    this.disableAuditApollo = (this.gdsCredentials && this.gdsCredentials.ApolloActive) ? false : true;
    this.disableAuditGalileo = (this.gdsCredentials && this.gdsCredentials.GalileoActive) ? false : true;
    this.disableAuditSabre = (this.gdsCredentials && this.gdsCredentials.SabreActive) ? false : true;
    this.disableAuditWorldspan = (this.gdsCredentials && this.gdsCredentials.WorldspanActive) ? false : true;
    this.originalKeywordList = data.RACFilters;
    this.accountType = data.AccountType;
    this.racAmadeus = this.disableAuditAmadeus || !this.editedAudit.AuditAmadeus ? "" : this.racAmadeus;// (data.property[0].AmadeusRateAccessCode && !this.disableAuditAmadeus) ? data.property[0].AmadeusRateAccessCode : "";
    this.racApollo = this.disableAuditApollo || !this.editedAudit.AuditApollo ? "" : this.racApollo;// (data.property[0].ApolloRateAccessCode && !this.disableAuditApollo) ? data.property[0].ApolloRateAccessCode : "";
    this.racGalileo = this.disableAuditGalileo || !this.editedAudit.AuditGalileo? "" : this.racGalileo;// (data.property[0].GalileoRateAccessCode && !this.disableAuditGalileo) ? data.property[0].GalileoRateAccessCode : "";
    this.racSabre = this.disableAuditSabre || !this.editedAudit.AuditSabre ? "" : this.racSabre;// (data.property[0].SabreRateAccessCode && !this.disableAuditSabre) ? data.property[0].SabreRateAccessCode : "";
    this.racWorldspan = this.disableAuditWorldspan || !this.editedAudit.AuditWorldspan ? "" : this.racWorldspan;// (data.property[0].WorldspanRateAccessCode && !this.disableAuditWorldspan) ? data.property[0].WorldspanRateAccessCode : "";
    const keywordManager = new KeywordManager();
    keywordManager.BreakdownList(data.RACFilters);
    this.keywordList = keywordManager.Keywords.map(d => { return { textContent: d } });
    if (this.data.ComparisonKeywords) {
      var newList = this.data.ComparisonKeywords.split(',').map(d => { return { textContent: d } });
      newList.forEach(element => {

        if (this.keywordList.filter(e => e.textContent === element.textContent).length <= 0) {
          this.keywordList.push(element)
        }
      });

    }
  };
  get editedAudit(): AuditStdEdit {
    return this._editedAudit;
  }
  disableAuditAmadeus: boolean = false;
  disableAuditApollo: boolean = false;
  disableAuditGalileo: boolean = false;
  disableAuditSabre: boolean = false;
  disableAuditWorldspan: boolean = false;

  lengthOfStay: string = "1";
  customeLengthOfStay: string = "";
  auditRequiresApprovalToStart: boolean = false;
  scheduledDate: Date;
  scheduledTime: Date;
  earliestRunDate: Date;
  lastRunDate: Date;
  LOSIsLicensed: boolean = false;
  gdsCredentials: GDSCredentials = new GDSCredentials();

  get invalidKeyword(): boolean {
    let keywordManager = new KeywordManager();
    let cleanedKeyword = keywordManager.CleanNoise(this.keywordToAdd.trim().toUpperCase());
    return cleanedKeyword == "";
  }

  addKeyordClick() {
    let keywordManager = new KeywordManager();
    let kw = this.keywordToAdd.trim().toUpperCase();
    kw = keywordManager.CleanNoise(kw);
    if (kw && kw != "")
      this.keywordList.push({ textContent: kw });
    this.keywordToAdd = "";
  }

  deleteKeyword(event) {
    const idx = this.keywordList.findIndex(keyword => keyword === event.item);
    this.keywordList.splice(idx, 1);
  }

  get showNotAvailableAmadeus(): boolean { return this.gdsCredentials && this.editedAudit && !this.gdsCredentials.AmadeusActive && this.editedAudit.AuditAmadeus };
  get showNotAvailableApollo(): boolean { return this.gdsCredentials && this.editedAudit && !this.gdsCredentials.ApolloActive && this.editedAudit.AuditApollo };
  get showNotAvailableGalileo(): boolean { return this.gdsCredentials && this.editedAudit && !this.gdsCredentials.GalileoActive && this.editedAudit.AuditGalileo };
  get showNotAvailableSabre(): boolean { return this.gdsCredentials && this.editedAudit && !this.gdsCredentials.SabreActive && this.editedAudit.AuditSabre };
  get showNotAvailableWorldspan(): boolean { return this.gdsCredentials && this.editedAudit && !this.gdsCredentials.WorldspanActive && this.editedAudit.AuditWorldspan };

  updateScheduleType(which: number) {
    this.runAuditNow = which === 0 ? true : false;
    this.auditWillBeScheduled = which === 0 ? false : true;
  }

  updateScheduledTime(event) {
    let dateTime: Date = event as Date;
    if (dateTime) {
      if (dateTime >= this.earliestRunDate && dateTime <= AddDaysToDate(new DateTime(this.lastRunDate, DateTime.Kind.Local), 1).toJsDate()) {
        this.scheduledTime = event;
      } else {
        this.scheduledTime = new Date(this.scheduledTime);
      }
    }
  }

  validateEmailAddress(address: string): boolean{
    let re = new RegExp("^(?:[a-z0-9!#$%&'*+\\/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+\\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)$","i");
    let m = address.match(re);
    return re.test(address) && m[0]===address;
  }

  validateGDSInfo():{ test:()=>boolean, message:string}{
    try {
      this.editedAudit.property.forEach(p => p.checkThatGDSPropertiesAreEntered(
        this.editedAudit.AuditAmadeus && p.ProcessAmadeus,
        this.editedAudit.AuditApollo && p.ProcessApollo,
        this.editedAudit.AuditGalileo && p.ProcessGalileo,
        this.editedAudit.AuditSabre && p.ProcessSabre,
        this.editedAudit.AuditWorldspan && p.ProcessWorldspan));
    } catch (error) {
      return { test:()=>true, message:error};;
    }
    return { test:()=>false, message:null};
  }
  validateBeforeCompleting(): boolean {
    let allowedTypes = ['C', 'N', 'X'];
    let re = new RegExp('(^[0-9]$)|(^[0-9][0-9]$)');
    this.customeLengthOfStay = this.customeLengthOfStay.trim();

    let validations = [
      { test: () => (!this.editedAudit.isAGDSSelected()), message: "You must provide at least one GDS to process." },
      { test: () => (this.keywordList.length <= 0), message: "You must provide at least one keyword to process." },
      { test: () => (!this.contractYear || this.contractYear.length <= 0), message: "You must select a Contract Year." },
      { test: () => (this.editedAudit.AccountName == "" || this.editedAudit.CustomerAccountID == ""), message: "Customer Account ID or Account Name are missing." },
      { test: () => (this.editedAudit.AccountName.length > 255), message: "Account Name is more than 255 characters." },
      { test: () => (this.editedAudit.CustomerAccountID.length > 25), message: "Customer Account ID is more than 25 characters." },
      { test: () => (this.lengthOfStay == "-1" && !this.customeLengthOfStay.match(re)), message: "Customer Length of stay is not a number." },
      { test: () => (!allowedTypes.includes(this.accountType)), message: "Account Type is not selected." },
      { test: () => (this.editedAudit.property.length <= 0), message: "No properties to audit" },
      { test: () => (this.editedAudit.property.length >= 4000), message: "reached 4000 property limit, with XXXX properties" },
      { test: () => (!(this.editedAudit.AuditContactEmailAddress) ), message: "Report Failed Emails To is empty" },
      { test: () => (!this.validateEmailAddress(this.editedAudit.AuditContactEmailAddress) ), message: "Report Failed Emails To is not a valid email" },
    ];

    if (this.isQuickAudit) {
      let amaRacCode = this.editedAudit.property[0].AmadeusRateAccessCode;
      let apolloRacCode = this.editedAudit.property[0].ApolloRateAccessCode;
      let galileoRacCode = this.editedAudit.property[0].GalileoRateAccessCode;
      let sabreRacCode = this.editedAudit.property[0].SabreRateAccessCode;
      let worldspanRacCode = this.editedAudit.property[0].WorldspanRateAccessCode;

      validations.push({ test: () => (this.editedAudit.AuditAmadeus && amaRacCode.length <= 0), message: "Missing Amadeus Rate Access Codes" });
      validations.push({ test: () => (this.editedAudit.AuditApollo && apolloRacCode.length <= 0), message: "Missing Apollo Rate Access Codes" });
      validations.push({ test: () => (this.editedAudit.AuditGalileo && galileoRacCode.length <= 0), message: "Missing Galileo Rate Access Codes" });
      validations.push({ test: () => (this.editedAudit.AuditSabre && sabreRacCode.length <= 0), message: "Missing Sabre Rate Access Codes" });
      validations.push({ test: () => (this.editedAudit.AuditWorldspan && worldspanRacCode.length <= 0), message: "Missing Worldspan Rate Access Codes" });
      validations.push({
        test: () => ((amaRacCode.length > 0 && !this.validateRacCodes(amaRacCode)) ||
          (apolloRacCode.length > 0 && !this.validateRacCodesForApolloGalileo(apolloRacCode)) ||
          (galileoRacCode.length > 0 && !this.validateRacCodesForApolloGalileo(galileoRacCode)) ||
          (sabreRacCode.length > 0 && !this.validateRacCodes(sabreRacCode))
          || (worldspanRacCode.length > 0 && !this.validateRacCodes(worldspanRacCode))
          ), message: "Rate Access Code must be 3 characters for Amadeus, Sabre and Worldspan and max 6 characters for Apollo and Galileo"
      });


    }
    validations.push(this.validateGDSInfo())
    var errors = validations.filter((validation) => validation.test())
      .map(validation => validation.message);

    if (errors.length > 0) {
      this.toConfirmDlg.confirmDlg("One or more items need attention.", errors.join("\r\n"), "Validation").subscribe();
      return false;
    }

    return true;
  }

  updateBeforeCompleting() {
    let d = this.editedAudit;
    d.LengthofStay = Number.parseInt(this.lengthOfStay);
    if (this.lengthOfStay == "-1") {
      d.LengthofStay = Number.parseInt(this.customeLengthOfStay);
    }
    d.NumberOfOccupants = 1;
    if (this.runAuditNow) {
      d.ScheduledRunDate = new Date(1900, 1, 1);
    } else {
      d.ScheduledRunDate = this.scheduledTime;
    }
    d.RequiresApproval = this.auditRequiresApprovalToStart;
    d.AuditApproved = this.auditRequiresApprovalToStart ? false : true;
    d.ApprovedBy = "";
    d.AccountType = this.accountType;
    d.SendNotifications = this.buildNotification;
    d.NotificationTemplateID = d.SendNotifications ? this.notificationSelection : "";
    d.NotificationTemplateName = d.SendNotifications ? (this._notificationTemplateList.find( (v)=> v.id == this.notificationSelection).name):"";
    const keywordManager = new KeywordManager();
    d.RACFilters = this.keywordList.map(d => '"' + d.textContent + '"').join(",");
    keywordManager.BreakdownList(d.RACFilters);
    d.RACFilters = keywordManager.GetCommaList();
  }

  SaveAudit(): Observable<MsgResult> {
    //this.editedAudit.property=[];
    return this.raService.SaveAudit(this.editedAudit);
  }

  OnCheckValueChange() {
    this.verifyEmailAdd.emit(this.validateEmail);
  }

  racCodeChanged(newRacCode) {
    if (newRacCode.target.value) {
      let isValid = null;
      if (newRacCode.target.id.includes('Apollo') || newRacCode.target.id.includes('Galileo')) {
        isValid = this.validateRacCodesForApolloGalileo(newRacCode.target.value);
      }
      else {
        isValid = this.validateRacCodes(newRacCode.target.value);
      }
      if (!isValid) {
        this.alerter.showAlertMessage(5000, 'Please enter valid Rate Access Code', EnumAlertType.Error);
      }
    }

    this.editedAudit.property.forEach((p) => {
      p.AmadeusRateAccessCode = this.racAmadeus.toUpperCase();
      p.ApolloRateAccessCode = this.racApollo.toUpperCase();
      p.GalileoRateAccessCode = this.racGalileo.toUpperCase();
      p.SabreRateAccessCode = this.racSabre.toUpperCase();
      p.WorldspanRateAccessCode = this.racWorldspan.toUpperCase();
    });
  }


  validateRacCodes(racCode) {
    let re = new RegExp('^[a-zA-Z0-9]{3}$');
    return re.test(racCode);
  }

  validateRacCodesForApolloGalileo(racCode) {
    let re = new RegExp('^[a-zA-Z0-9]{1,6}$');
    return re.test(racCode);
  }
}
